import { makeStyles } from '@material-ui/core/styles';

export const attributeTextStyles = makeStyles({
  verysmall: {
    fontSize: 13,
  },
  small: {
    fontSize: 14,
  },
  large: {
    fontSize: 18,
  },
});

export const attributeTextBackgroundStyles = makeStyles({
  billableDiv : {
    background: 'rgb(0, 150, 136)',
    color: 'white',
    width: 'fit-content',
    padding: '1px 15px',
    borderRadius: '10px'
  },
  nonBillableDiv : {
    background: '#EF5350',
    color: 'white',
    width: 'fit-content',
    padding: '1px 15px',
    borderRadius: '10px'
  }
});
